import { IdentityDto } from './../shared/identity.dto';

export class AddressDto {
  identity = new IdentityDto();
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  city: string;
  country: string;
  latitude: string;
  longitude: string;
  state: string;
  type: string;
  zipCode: string;

  constructor(d?: AddressDto) {
    if (!d) {
      return;
    }
    this.identity = new IdentityDto(d.identity);
    this.addressLine1 = d.addressLine1;
    this.addressLine2 = d.addressLine2;
    this.addressLine3 = d.addressLine3;
    this.city = d.city;
    this.country = d.country;
    this.latitude = d.latitude;
    this.longitude = d.longitude;
    this.state = d.state;
    this.type = d.type;
    this.zipCode = d.zipCode;
  }
}
